<template>
	<!-- Left div because b-navbar does not trigger on mouseenter / mouseleave events -->
	<div
		class="sidenav navbar navbar-vertical fixed-left navbar-expand-xs navbar-light bg-white"
		@mouseenter="$sidebar.onMouseEnter()"
		@mouseleave="$sidebar.onMouseLeave()"
		:data="backgroundColor"
	>
		<div class="scrollbar-inner" ref="sidebarScrollArea">
			<div class="sidenav-header d-flex align-items-center">
				<b-navbar-brand href="#">
					<img v-bind:src="pageLogo" :style="logoStyle" class="navbar-brand-img" :alt="`${customer} logo`" /><br />
				</b-navbar-brand>
				<div class="ml-auto">
					<!-- Sidenav toggler -->
					<div
						class="sidenav-toggler d-none d-xl-block"
						:class="{active: !$sidebar.isMinimized}"
						@click="minimizeSidebar"
					>
						<div class="sidenav-toggler-inner">
							<i class="sidenav-toggler-line"></i>
							<i class="sidenav-toggler-line"></i>
							<i class="sidenav-toggler-line"></i>
						</div>
					</div>
				</div>
			</div>
			<slot></slot>
			<div class="navbar-inner">
				<b-navbar-nav>
					<slot name="links">
						<sidebar-item v-for="(link, index) in sidebarLinks" :key="link.name + index" :link="link">
							<sidebar-item
								v-for="(subLink, index) in link.children"
								:key="subLink.name + index"
								:link="subLink"
							>
							</sidebar-item>
						</sidebar-item>
					</slot>
				</b-navbar-nav>
				<slot name="links-after"></slot>
			</div>
		</div>
	</div>
</template>
<script>

export default {
	// eslint-disable-next-line
	name: "sidebar",
	props: {
		title: {
			type: String,
			default: "DCC Portal",
			description: "Sidebar title",
		},
		shortTitle: {
			type: String,
			default: "PP",
			description: "Sidebar short title",
		},
		// logo: {
		//   type: String,
		//   default: this.pageLogo,
		//   description: 'Sidebar app logo'
		// },
		backgroundColor: {
			type: String,
			default: "vue",
			validator: value => {
				let acceptedValues = ["", "vue", "blue", "green", "orange", "red", "primary"];
				return acceptedValues.indexOf(value) !== -1;
			},
			description: "Sidebar background color (vue|blue|green|orange|red|primary)",
		},
		sidebarLinks: {
			type: Array,
			default: () => [],
			description: "List of sidebar links as an array if you don't want to use components for these.",
		},
		autoClose: {
			type: Boolean,
			default: true,
			description: "Whether sidebar should autoclose on mobile when clicking an item",
		},
	},
	data() {
		return {
			pageTitle: "DCC Portal",
			pageLogo: "",
			logoStyle: "",
			customer: process.env.VUE_APP_CLIENT,
		};
	},
	provide() {
		return {
			autoClose: this.autoClose,
		};
	},
	methods: {
		minimizeSidebar() {
			if (this.$sidebar) {
				this.$sidebar.toggleMinimize();
			}
		},
		properCase(string) {
			return string.charAt(0).toUpperCase() + string.slice(1);
		},
	},
	mounted() {
		this.$sidebar.isMinimized = this.$sidebar.breakpoint < window.innerWidth;

    this.pageTitle = process.env.VUE_APP_CLIENT.toString().toUpperCase()+' Portal'
    this.pageLogo = '/img/brand/'+process.env.VUE_APP_CLIENT.toString() +'.png';

		let width = `137px`;
		let height = `96px`;
		this.logoStyle = `width: ${width}; height: ${height}`;
		this.minimizeSidebar();
	},
	beforeDestroy() {
		if (this.$sidebar.showSidebar) {
			this.$sidebar.showSidebar = false;
		}
	},
};
</script>
